import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/pages/home/components/HeroSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import MediaSection from '@/pages/home/components/MediaSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import AppSection from '@/pages/home/components/AppSection';
import FaqSection from '@/pages/home/components/FaqSection';
import IndexSection from '@/pages/home/components/IndexSection';
import CardsSection from '@/pages/home/components/CardsSection';
import RankingSection from '@/pages/home/components/RankingSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import ContactSection from '@/pages/home/components/ContactSection';
import AboutSection from '@/pages/home/components/AboutSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <TopicsSection />
        <MediaSection />
        <CommentsSection />
        <FeaturesSection />
        <CarouselSection />
        <AppSection />
        <FaqSection />
        <IndexSection />
        <CardsSection />
        <RankingSection />
        <UpdatesSection />
        <ContactSection />
        <AboutSection />
      </main>
      <Footer />
    </>
  );
}